<h2 mat-dialog-title>{{(data.title | translate) | async}}</h2>
<mat-dialog-content>
    <p class="mb-5">{{(data.message | translate) | async}}</p>
    <app-dynamic-form *ngIf="formGroup " [formGroup]="formGroup" [inputForm]="data.inputForm"
        [appearanceForm]="'outline'"></app-dynamic-form>
</mat-dialog-content>

<div *ngIf="data.uploadFile" class="w-full">


    <div class="flex w-full items-center justify-center bg-grey-lighter p-2 mb-4 group">
        <label
            class="w-full flex flex-col items-center px-6 py-6 bg-white text-blue rounded-lg border-2 border-[#223e80] border-dashed tracking-wide uppercase   cursor-pointer hover:bg-[#223e80] hover:text-white">

            <img src='../../../../assets/svg/up.svg' class="w-8 h-8 text-[#223e80] " />
            <span class="mt-2 text-base leading-normal ">{{utils.traslatei18n('Select a file')}}</span>
            <input type='file' (change)="incomingfile($event)" class="hidden" accept=".pdf, .doc, .xlsx, .txt" />

        </label>
    </div>

    <div *ngFor="let item of file; let i = index">
        <button mat-button>
            <div class="flex flex-row justify-between items-center" (click)="deleteFile(i)">
                <div class="mt-2 text-base leading-normal ">{{item.name}}</div>
                <mat-icon class="mx-2">delete</mat-icon>
            </div>

        </button>
        <div *ngIf="sizeError(i) && data.uploadFile" class="text-red-500">
            {{utils.traslatei18n('uploaded file is too large')}}
        </div>
    </div>

</div>


<mat-dialog-actions class="justify-between">
    <button mat-button mat-dialog-close color="accent">{{'cancel'|translate| async}}</button>
    <!-- The mat-dialog-close directive optionally accepts a value as a result for the dialog. -->
    <button mat-flat-button [disabled]="!formGroup.valid" [color]="data.confirmButtonColor || 'accent'"
        [mat-dialog-close]="returnValueDialog()">{{(data.confirmButtonText || 'confirm' |
        translate)
        | async}}</button>

</mat-dialog-actions>